/**
 * ЕДИНСТВЕННОЕ место бренда (правило №3 CLAUDE.md, ADR 0001/0006).
 * Смена имени или домена = правка этого файла (+ deploy/-конфиг nginx).
 * Проверка, что бренд не расползся: `pnpm check:brand`.
 */

/**
 * Канонический домен. Собственный домен владельца (01.08.2026): переезд с
 * временного vesti24.eu, на котором QR печатать было нельзя.
 */
const domain = 'dga.ee'

export const BRAND = {
  /** Имя продукта для UI и <title>. */
  productName: 'DGA',
  domain,
  /**
   * Домен зафиксирован — тиражи QR печатать МОЖНО (ADR 0004: путь и параметры
   * ссылки неизменны навсегда, менять их после печати нельзя).
   */
  domainIsTemporary: false,
  /**
   * Прежние домены проекта (ADR 0006): на них ещё могут жить тестовые QR и
   * ссылки июля 2026. Сервер их с 01.08.2026 не обслуживает (решение владельца),
   * поэтому клиенты считают такой хост своим: origin ссылки → baseUrl.
   * Зеркало — BrandConfig.legacyHosts в flutter/app/lib/brand.dart.
   */
  legacyDomains: ['vesti24.eu'],
  baseUrl: `https://${domain}`,
  /** URL-схема deep links мобильного приложения. */
  urlScheme: 'dga',
  /**
   * Идентификаторы приложения — единый источник для обеих платформ. Обратная
   * запись домена; iOS и Android ОДИНАКОВЫ намеренно (урок TecTactic: их
   * расхождение стоило дорого).
   */
  bundleIdIos: 'ee.dga.app',
  applicationIdAndroid: 'ee.dga.app',
  /** Фон знака (иконка/сплэш): знак = QR-уголок → линия → пин (web/public/icon.svg). */
  iconBg: '#2B5CFF',
} as const

/**
 * Контракт QR-ссылок (ADR 0004): путь и параметры неизменны навсегда.
 * `https://{domain}/v/{venue}?a={anchor}&to={poi}&list={keys}`
 * `list` добавлен 03.08.2026 (список покупок) — контракт аддитивен: новые
 * параметры допустимы, менять/удалять существующие нельзя.
 */
export function venueUrl(
  venueId: string,
  params?: { anchor?: string; to?: string; list?: string },
): string {
  const url = new URL(`/v/${venueId}`, BRAND.baseUrl)
  if (params?.anchor) url.searchParams.set('a', params.anchor)
  if (params?.to) url.searchParams.set('to', params.to)
  if (params?.list) url.searchParams.set('list', params.list)
  return url.toString()
}

/**
 * Добавочный параметр `&r=` — путь к ближайшему выходу, зашитый в саму
 * табличку (Google polyline, точность 5). Контракт ADR 0004 аддитивен: старые
 * параметры не трогаем, вьюер без поддержки `r` просто его игнорирует.
 *
 * Значение кодируем `encodeURIComponent`, а не `URLSearchParams`: тот
 * form-кодирует `~`, `!`, `*` и раздувает QR, а алфавит polyline — ASCII
 * 63..126, где `&`, `=`, `#`, `+` не встречаются, так что разделители
 * ссылки в опасности не бывают.
 */
export function withSignRoute(url: string, polyline: string): string {
  if (!polyline) return url
  const sep = url.includes('?') ? '&' : '?'
  return `${url}${sep}r=${encodeURIComponent(polyline)}`
}
